import SchemaStructuredData, {
	SchemaStructuredDataProps as _SchemaStructuredDataProps,
} from './SchemaStructuredData';

export { SchemaStructuredData };
export type SchemaStructuredDataProps = _SchemaStructuredDataProps;
